// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1yGR8","filesListContainer":"PosDisputesFiles_filesListContainer__3L2vC","filesButton":"PosDisputesFiles_filesButton__1_VE3"};